<script>
import PbColorInput from '@/components/PbColorInput/PbColorInput.vue'
import WithLoader from '@/components/WithLoader'

export default WithLoader(PbColorInput, {
  events: ['input'],
  pendingProp: 'loading',
})
</script>
